var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAeroplaneIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_780_5231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.13146 2.68934L13.9995 8.00001L3.13146 13.3107C3.06943 13.3345 3.00171 13.3394 2.9369 13.3247C2.87209 13.31 2.81312 13.2763 2.76746 13.228C2.72047 13.1784 2.68813 13.1168 2.67401 13.05C2.65989 12.9831 2.66454 12.9137 2.68746 12.8493L4.3328 8.00001L2.68746 3.15068C2.66454 3.08633 2.65989 3.01689 2.67401 2.95005C2.68813 2.88321 2.72047 2.82159 2.76746 2.77201C2.81312 2.72371 2.87209 2.69007 2.9369 2.67535C3.00171 2.66063 3.06943 2.6655 3.13146 2.68934Z",
    stroke: "#B3B8C1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 8H14.0007",
    stroke: "#B3B8C1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_780_5231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeroplaneIcon);
export default __webpack_public_path__ + "static/media/AeroplaneIcon.7fbcc7336fd46e97d014447039d7de82.svg";
export { ForwardRef as ReactComponent };